<script setup>
import { ref } from 'vue';
import CarCard from '@/components/cards/CarCard.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination } from 'swiper/modules';
defineProps({
  items: {
    type: Array,
    required: true,
    default: () => [],
  },
  backgroundColor: {
    type: String,
    default: () => '',
  },
  view: {
    type: String,
    required: true,
    default: 'default',
    validator: (value) => {
      return ['default', 'compact'].includes(value);
    },
  },
});
const isLocked = ref(true);
const onSwiper = (swiper) => {
  isLocked.value = swiper.isLocked;
};

const onLockToggle = (swiper) => {
  isLocked.value = swiper.isLocked;
};
</script>
<template>
  <div class="cars-slider">
    <Swiper
      data-aos="fade-up"
      data-aos-easing="ease-out-cubic"
      :slides-per-view="'auto'"
      :space-between="16"
      :modules="[Navigation, Pagination]"
      :navigation="{
        prevEl: '.cars-slider__navigation-prev',
        nextEl: '.cars-slider__navigation-next',
      }"
      :pagination="{
        el: '.cars-slider__pagination',
        clickable: true,
      }"
      @swiper="onSwiper"
      @lock="onLockToggle"
      @unlock="onLockToggle"
    >
      <SwiperSlide v-for="(item, index) in items" :key="index">
        <CarCard
          :background-color="backgroundColor"
          :view="view"
          :url="item?.url"
          :in-stock="item?.in_stock"
          :image="item?.image || item?.thumbnails || item?.brand"
          :empty-image="!item?.image && !item?.thumbnails"
          :name="item?.title"
          :price="item?.pricing?.price_old"
          :discount="item?.pricing?.discount"
          :current-price="item?.pricing?.price_current"
          :currency="item?.pricing?.currency"
          :max-payment="item?.financing?.max_payment"
          :monthly-payment="item?.financing?.monthly_payment"
          :kasko="item?.financing?.kasko"
          :tooltip="item?.financing?.tooltip"
          :parameters="item?.parameters"
          :is-stock-car="item.status_car === 'stock'"
        />
      </SwiperSlide>
    </Swiper>
    <div
      v-show="!isLocked"
      class="swiper-pagination cars-slider__pagination"
      data-aos="fade-up"
      data-aos-easing="ease-out-cubic"
    ></div>
    <div
      v-show="!isLocked"
      class="swiper-navigation cars-slider__navigation"
      data-aos="fade-up"
      data-aos-easing="ease-out-cubic"
    >
      <Button
        type="button"
        rounded
        variant="outlined"
        class="cars-slider__navigation-prev button-prev js-button-car-equipment-prev"
      >
        <CIcon
          class="button-prev__icon"
          :name="
            backgroundColor === 'black' ? 'direction-white' : 'direction-black'
          "
          width="16"
          height="16"
        />
      </Button>
      <Button
        type="button"
        rounded
        variant="outlined"
        class="cars-slider__navigation-next button-next js-button-car-equipment-next"
      >
        <CIcon
          class="button-next__icon"
          :name="
            backgroundColor === 'black' ? 'direction-white' : 'direction-black'
          "
          width="16"
          height="16"
        />
      </Button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.cars-slider {
  .swiper {
    height: 100%;
    overflow: visible;
    width: 100%;
  }
  .swiper-slide {
    align-self: stretch;
    height: auto;
    max-width: calc(100vw - 48px);
    width: 328px;
    @include media-breakpoint-up(sm) {
      width: 356px;
    }
    @include media-breakpoint-up(md) {
      width: 384px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(width, 384);
    }
  }
}
</style>
